import type { PermissionMode } from "@/lib/chat";
import { useToastStore } from "@/stores/useToastStore";

const NEW_CHAT_PERMISSION_MODE_STORAGE_KEY = "izanagi.newChatPermissionMode";

function parsePermissionMode(value: unknown): PermissionMode {
	return value === "manual" ? "manual" : "acceptEdits";
}

/**
 * 新規チャット作成用の既定確認モード。保存値が無い・壊れている場合は Accept Edits。
 *
 * エラーハンドリング規約 (再スロー必須) の明示的な例外: localStorage が無効な環境で再スローすると
 * 呼び出し元のチャット作成自体が失敗する。表示既定値のために作成を止めるのは本末転倒なので、
 * トーストで「自動承認になる」ことをユーザーに通知したうえで既定値へ倒して継続する。
 */
export function readNewChatPermissionMode(): PermissionMode {
	try {
		return parsePermissionMode(window.localStorage.getItem(NEW_CHAT_PERMISSION_MODE_STORAGE_KEY));
	} catch (err: unknown) {
		console.error("確認モード設定の読み込みに失敗しました", err);
		useToastStore.getState().show({
			type: "error",
			message: "確認モード設定を読み込めませんでした。自動承認モードで続行します。",
		});
		return "acceptEdits";
	}
}

export function writeNewChatPermissionMode(mode: PermissionMode): void {
	window.localStorage.setItem(NEW_CHAT_PERMISSION_MODE_STORAGE_KEY, mode);
}
